var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMergePdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FFC1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H14C12.1144 20 11.1716 20 10.5858 20.5858C10 21.1716 10 22.1144 10 24V26C10 27.8856 10 28.8284 10.5858 29.4142C11.1716 30 12.1144 30 14 30H16C17.8856 30 18.8284 30 19.4142 29.4142C20 28.8284 20 27.8856 20 26V25",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H19C17.1144 15 16.1716 15 15.5858 15.5858C15 16.1716 15 17.1144 15 19V21C15 22.8856 15 23.8284 15.5858 24.4142C16.1716 25 17.1144 25 19 25H21C22.8856 25 23.8284 25 24.4142 24.4142C25 23.8284 25 22.8856 25 21V20",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14C20 12.1144 20 11.1716 20.5858 10.5858C21.1716 10 22.1144 10 24 10H26C27.8856 10 28.8284 10 29.4142 10.5858C30 11.1716 30 12.1144 30 14V16C30 17.8856 30 18.8284 29.4142 19.4142C28.8284 20 27.8856 20 26 20H24C22.1144 20 21.1716 20 20.5858 19.4142C20 18.8284 20 17.8856 20 16V14Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMergePdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/merge-pdf.47adc4bceb5f7cc699fedcee9e1fdae3.svg";